import { render, staticRenderFns } from "./c_notice.vue?vue&type=template&id=01bc1722&scoped=true"
import script from "./c_notice.vue?vue&type=script&lang=js"
export * from "./c_notice.vue?vue&type=script&lang=js"
import style0 from "./c_notice.vue?vue&type=style&index=0&id=01bc1722&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc1722",
  null
  
)

export default component.exports